const Categories = {
  FOOD: 'Food',
  DRINKS: 'Drinks'
}

export default Categories
